import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Tooltip } from '@mui/material';
import type { MetricRegistryMeta } from '../types';
import { useMetricInfo } from '../hooks/useMetricInfo';
import MetricInfoPopover from './MetricInfoPopover';

type Props = {
  registry?: MetricRegistryMeta | null;
};

/** RBAC `MetricInfo`: info icon left of query copy; opens registry popover. */
export default function MetricInfoButton({ registry }: Props) {
  const {
    showButton,
    open,
    anchorEl,
    handleOpen,
    handleClose,
    metricKey,
    businessDefinition,
    catalogId,
  } = useMetricInfo(registry);

  if (!showButton) return null;

  return (
    <>
      <Tooltip title="Metric info">
        <IconButton
          size="small"
          aria-label="Metric info"
          onClick={handleOpen}
          sx={{ color: 'text.secondary', p: 0.5 }}
        >
          <InfoOutlinedIcon sx={{ fontSize: '1.1rem' }} />
        </IconButton>
      </Tooltip>
      <MetricInfoPopover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        metricKey={metricKey}
        businessDefinition={businessDefinition}
        catalogId={catalogId}
      />
    </>
  );
}
